ul-how-it-works-type-1 {
  display: block;
  background-color: var(--background-color-primary);

  .ul-how-it-works-type-1__container {
    max-width: px-to-rem(1312px);
    margin: 0 auto;
    padding: var(--spacing-6xl) var(--spacing-xl);

    @include desktop {
      padding: var(--spacing-6xl) px-to-rem(64px);
    }
  }

  // Heading — always centered, Graphik Bold 40px
  me-heading {
    display: block;
    margin-bottom: var(--spacing-2xl);
    text-align: center;

    .me-heading {
      font-size: px-to-rem(40px);
      line-height: px-to-rem(48px);
      font-weight: map-get($font-weights, bold);
      text-align: center;
      color: var(--text-color-primary);
    }
  }

  // Items list — horizontal row on desktop
  .ul-how-it-works-type-1__list {
    list-style: none;
    margin: 0;
    padding: 0;
    display: flex;
    flex-direction: column;
    gap: var(--spacing-3xl);

    @include desktop {
      flex-direction: row;
      align-items: flex-start;
      gap: var(--spacing-4xl); // 48px
    }
  }

  // Each item: icon (48px) + title, horizontal flex
  .ul-how-it-works-type-1__item {
    display: flex;
    flex-direction: row;
    align-items: flex-start;
    gap: var(--spacing-2xl); // 24px between icon and text
    flex: 1;
  }

  // Icon wrapper — fixed 48×48px
  .ul-how-it-works-type-1__image-wrapper {
    flex-shrink: 0;
    display: flex;
    align-items: flex-start;
    width: px-to-rem(48px);
    height: px-to-rem(48px);
  }

  .ul-how-it-works-type-1__image {
    width: px-to-rem(48px);
    height: px-to-rem(48px);
    object-fit: contain;
  }

  // Content — title only (Graphik Bold 20px, lh 1.4)
  .ul-how-it-works-type-1__content {
    flex: 1;
    margin: 0;
    padding-top: px-to-rem(4px); // slight visual alignment with icon top
  }

  .ul-how-it-works-type-1__title {
    display: block;
    margin: 0; // reset default <h3> margins so it renders like the former <strong>
    font-family: $uslf-font-family-heading;
    font-size: px-to-rem(20px);
    font-weight: map-get($font-weights, bold);
    line-height: 1.4;
    color: var(--text-color-primary);
  }

  // Hide description if present (not in Figma design)
  .ul-how-it-works-type-1__description {
    display: none;
  }
}
